import {
	GET_SCOTS_FOR_ASSERTIONID,
	GET_ALL_SCOTS,
	GET_SCOT_BY_ID,
	CLEAR_SCOT,
	UPDATE_SCOT,
	CREATE_SCOT,
	SAVE_RISK_WCGW_SELECTION,
	DELETE_SCOT_BY_ID,
	UNRELATING_ACCOUNT_FROM_SCOT,
	UPDATE_SCOT_ACCOUNT_RELATION,
	UPDATE_STORE_RELATE_CONTROL_TO_WCGW,
	UPDATE_STORE_UNRELATE_CONTROL_FROM_WCGW,
	ADD_SCOT_WCGW_RELATION,
	UPDATE_SCOT_WCGW_RELATION,
	UPDATE_UNRELATE_ITAPPLICATION_FROM_SCOT,
	SET_LOADER_FOR_RELATED_TASK,
	ADD_SCOT_RELATED_TASK,
	LINK_SCOT_RELATE_TASK,
	UNLINK_SCOT_RELATE_TASK,
	MANAGE_ITAPPLICATION_FROM_BUILD_STEP_2,
	POST_KNOWLEDGE_SCOT,
	POST_KNOWLEDGE_WCGW,
	UNRELATE_ACCOUNT_FROM_ALL_SCOTS_WHEN_DELETED,
	POST_KNOWLEDGE_CONTROL,
	MODIFY_ITAPPLICATION_TO_SCOT,
	CLEAR_ITAPPSO_SCOT,
	UPDATE_ALL_ACCOUNT_IN_SCOTLIST_WHEN_ACCOUNT_UPDATED,
	FILTER_SCOTS_BY_ACCOUNT_TYPE
} from '../../actions/actiontypes';
import {HttpStatusCodes, AccountType} from '../../util/uiconstants';
import {isApiResponseOk} from '../../util/utils';
import initialstate from '../initialstate';
import {isEmpty, cloneDeep} from 'lodash';

export default function scotsReducer(state = initialstate.scots, action) {
	function deleteAccountFromScot(accountList, accountId) {
		let accounts = accountList?.filter((account) => account.accountId !== accountId);
		return accounts;
	}
	function updateWCGWFromScot(wcgwList, WcgwName, wcgwId) {
		let wcgw = wcgwList?.map((wcgw) => (wcgw.id === wcgwId ? {...wcgw, wcgwName: WcgwName} : wcgw));
		return wcgw;
	}

	function updateRelatedTask(scots, scotId, isSorting = false) {
		let scotIndex = scots?.data?.findIndex((scot) => scot.id === scotId);
		if (scotIndex !== -1) {
			scots.data[scotIndex].relatedTasks.push(action.payload);
			if (isSorting) {
				scots.data[scotIndex].relatedTasks.sort((a, b) => {
					const aValue = a.taskDisplayName;
					const bValue = b.taskDisplayName;
					return aValue.localeCompare(bValue, undefined, {numeric: true, sensivity: 'base'});
				});
			}
			scots.data[scotIndex].addTaskLoader = false;
		}
		return scots;
	}

	const deleteScotFromState = (scotId) => {
		let tempState = cloneDeep(state);
		tempState.data = tempState?.data?.filter((scot) => scot.id !== Number(scotId));
		return tempState;
	};

	function deleteControlFromScot(controlId) {
		let tempState = cloneDeep(state);
		tempState?.data?.forEach((scot) => {
			scot.controls = scot?.controls?.filter((control) => control.id !== controlId);
		});
		return tempState;
	}

	switch (action.type) {
		case GET_SCOTS_FOR_ASSERTIONID:
			return action.response || state;

		case GET_ALL_SCOTS:
			return action.response || state;

		case GET_SCOT_BY_ID:
			if (isApiResponseOk(action)) {
				return {
					...state,
					selectedScot: action.response
				};
			} else if (action?.error?.response?.status === HttpStatusCodes.NotFound) {
				return deleteScotFromState(action.scotId); // If the Scot is not found, remove it from the list (concurrency scenario)
			}
			return state;

		case CLEAR_SCOT:
			return {
				...state,
				selectedScot: null
			};

		case UPDATE_SCOT:
			if (!isEmpty(action.response)) {
				let newState = cloneDeep(state);
				const editIndex = newState?.data?.findIndex((x) => x.id === action.response.id);
				const scot = newState.data[editIndex];
				newState.data[editIndex] = {...scot, ...action.response};
				return {
					...newState,
					selectedScot: action.response,
					scotITApplications: action?.meta?.api?.data?.itApplications,
					scotITSOs: action?.meta?.api?.data?.itsOs
				};
			} else if (action?.error?.response?.status === HttpStatusCodes.BadRequest) {
				// If the Scot is not found, remove it from the list (concurrency scenario)
				return deleteScotFromState(action?.meta?.api?.data?.id);
			}
			return state;

		case CREATE_SCOT:
			if (!isEmpty(action.response)) {
				let newState = cloneDeep(state);
				newState?.data?.push(action.response);
				newState?.data?.sort((a, b) => a.scotName.localeCompare(b.scotName));
				return {
					...newState,
					selectedScot: action.response,
					scotITApplications: action?.meta?.api?.data?.itApplications,
					scotITSOs: action?.meta?.api?.data?.itsOs
				};
			}
			return state;

		case SAVE_RISK_WCGW_SELECTION: {
			let temp = null;
			if (isApiResponseOk(action)) {
				temp = cloneDeep(state);
				temp[0].scots.map((x) => {
					if (x.scotId === action.scotId) {
						for (let i = 0; i < action.data.length; i++) {
							let actionWcgw = action.data[i];
							for (let j = 0; j < x.wcgWs.length; j++) {
								if ('/Wcgw/' + x.wcgWs[j].id === actionWcgw.id) {
									x.wcgWs[j] = {...x.wcgWs[j], selected: actionWcgw.checked};
								}
							}
						}
					}
					return x;
				});
			}
			return temp || state;
		}

		case POST_KNOWLEDGE_SCOT: {
			if (isApiResponseOk(action)) {
				const newState = {
					...state,
					data: [...(state.data || []), action.response]
				};

				newState?.data?.sort((a, b) => a.scotName.localeCompare(b.scotName));
				return newState;
			}
			return state;
		}

		case DELETE_SCOT_BY_ID: {
			if (isApiResponseOk(action) || action?.error?.response?.status === HttpStatusCodes.NotFound) {
				return deleteScotFromState(action.scotId);
			}
			return state;
		}

		case UNRELATING_ACCOUNT_FROM_SCOT: {
			let scots = {...state};
			if (scots.data) {
				let newScotList = scots.data.map((scot) => {
					if (scot.id === action.meta.scotId) {
						scot = {...scot, accounts: deleteAccountFromScot(scot.accounts, action.meta.accountId)};
					}
					return scot;
				});
				scots.data = newScotList;
				return scots;
			} else {
				return state;
			}
		}
		case UPDATE_SCOT_ACCOUNT_RELATION: {
			let scots = cloneDeep(state);
			let scotIndex = scots.data.findIndex((scot) => scot.id === action.payload.scotId);
			if (scotIndex !== -1) {
				if (scots.data[scotIndex].accounts === undefined || scots.data[scotIndex].accounts === null) {
					scots.data[scotIndex] = {...scots.data[scotIndex], accounts: []};
				}
				scots.data[scotIndex].accounts.push(action.payload);
			}
			scots.data[scotIndex].accounts?.sort((a, b) => a.accountName.localeCompare(b.accountName));

			return scots;
		}
		case UPDATE_STORE_RELATE_CONTROL_TO_WCGW: {
			let scots = cloneDeep(state);
			let scotIndex = scots.data.findIndex((scot) => scot.id === action.payload.scotId);
			if (scotIndex !== -1) {
				scots.data[scotIndex].controls.push(action.payload.controlData);
				scots.data[scotIndex].controls.sort((a, b) => a.controlName.localeCompare(b.controlName));
			}
			return scots;
		}

		case UPDATE_STORE_UNRELATE_CONTROL_FROM_WCGW: {
			let scots = cloneDeep(state);
			let scotIndex = scots.data.findIndex((scot) => scot.id === action.payload.scotId);
			let controlIndex = scots.data[scotIndex].controls.findIndex(
				(control) =>
					control.id === action.payload.controlId &&
					control.wcgwId === action.payload.wcgwId &&
					control.scotId === action.payload.scotId
			);
			if (controlIndex !== -1) {
				scots.data[scotIndex].controls.splice(controlIndex, 1);
			}
			return scots;
		}

		case POST_KNOWLEDGE_WCGW: {
			if (isApiResponseOk(action)) {
				const scots = cloneDeep(state);
				if (scots?.data) {
					const scotIndex = scots.data?.findIndex((scot) => scot.id === action.response.scotId);
					if (scotIndex !== -1) {
						const wcgWs = scots.data[scotIndex]?.wcgWs || [];
						wcgWs.push({id: action?.response?.wcgwId, ...action.response});
						wcgWs.sort((a, b) => a.wcgwName.localeCompare(b.wcgwName));
						scots.data[scotIndex] = {...scots.data[scotIndex], wcgWs: wcgWs};
					}
					return scots;
				}
				return scots;
			}
			return state;
		}

		case POST_KNOWLEDGE_CONTROL: {
			if (isApiResponseOk(action)) {
				const {wcgwIds} = action?.meta?.api?.data ?? {};
				const scots = cloneDeep(state);
				if (scots?.data) {
					scots.data = scots.data.map((scot) => {
						if (scot?.wcgWs?.length === 0) return scot;
						const scotWcgwIdSet = new Set(scot?.wcgWs?.map((wcgw) => wcgw.id));
						const newControls = wcgwIds
							.filter((wcgwId) => scotWcgwIdSet.has(wcgwId))
							.map((wcgwId) => ({scotId: scot.id, wcgwId, ...action.response}));
						scot.controls = [...(scot.controls || []), ...newControls];
						scot.controls.sort((a, b) => a.controlName.localeCompare(b.controlName));
						return scot;
					});
				}
				return scots;
			}
			return state;
		}

		case MODIFY_ITAPPLICATION_TO_SCOT: {
			const scots = cloneDeep(state);
			const scotIndex = scots.data.findIndex((scot) => scot.id === action.payload.scotId);
			if (scotIndex !== -1) {
				scots.data[scotIndex].itApplications = [...action.payload.itAppSO];
				scots.data[scotIndex].itApplications?.sort((currentITApplication, nextITApplication) =>
					currentITApplication.itApplicationName.localeCompare(nextITApplication.itApplicationName)
				);
			}
			return scots;
		}

		case CLEAR_ITAPPSO_SCOT:
			return {
				...state,
				selectedScot: null,
				scotITApplications: null,
				scotITSOs: null
			};

		case ADD_SCOT_WCGW_RELATION: {
			let scots = cloneDeep(state);
			let scotIndex = scots.data.findIndex((scot) => scot.id === action.scotId);
			if (scotIndex !== -1) {
				scots.data[scotIndex].wcgWs.push(action.payload);
				scots.data[scotIndex].wcgWs.sort((a, b) => a.wcgwName.localeCompare(b.wcgwName));
			}
			return scots;
		}

		case UPDATE_SCOT_WCGW_RELATION: {
			let scots = {...state};
			if (scots.data) {
				let newScotList = scots.data.map((scot) => {
					if (scot.id === action.scotId) {
						scot = {...scot, wcgWs: updateWCGWFromScot(scot.wcgWs, action.wcgwName, action.wcgwId)};
					}
					return scot;
				});
				scots.data = newScotList;
				return scots;
			} else {
				return state;
			}
		}

		case UPDATE_UNRELATE_ITAPPLICATION_FROM_SCOT: {
			let scots = cloneDeep(state);
			let scotIndex = scots.data.findIndex((scot) => scot.id === action.payload.scotId);
			let itAppSOIndex = scots.data[scotIndex].itApplications.findIndex(
				(itApp) => itApp.id === action.payload.itAppSOId
			);
			if (itAppSOIndex !== -1) {
				scots.data[scotIndex].itApplications.splice(itAppSOIndex, 1);
			}
			return scots;
		}

		case SET_LOADER_FOR_RELATED_TASK: {
			if (action.scot) {
				let scots = cloneDeep(state);
				let scotIndex = scots.data.findIndex((scot) => scot.id === action.scot.id);
				if (scotIndex !== -1) {
					scots.data[scotIndex].addTaskLoader = true;
				}
				return scots;
			}
			return state;
		}
		case ADD_SCOT_RELATED_TASK: {
			let scots = cloneDeep(state);
			return updateRelatedTask(scots, action.payload.scotId);
		}
		case LINK_SCOT_RELATE_TASK: {
			if (action.payload) {
				if (isApiResponseOk(action)) {
					let scots = cloneDeep(state);
					return updateRelatedTask(scots, action.payload.scotId, true);
				}
				return state;
			}
			return state;
		}
		case UNLINK_SCOT_RELATE_TASK:
			if (action.payload) {
				if (isApiResponseOk(action)) {
					let scots = cloneDeep(state);
					let scot = scots?.data.find((scot) => scot.id === action.payload.scotId);
					if (scot) {
						let relatedTaskIndex = scot.relatedTasks.findIndex(
							(task) => task.id === action.payload.taskId || task.taskId === action.payload.taskId
						);
						if (relatedTaskIndex !== -1) {
							scot.relatedTasks.splice(relatedTaskIndex, 1);
						}
					}
					return scots;
				}
				return state;
			}
			return state;
		case MANAGE_ITAPPLICATION_FROM_BUILD_STEP_2: {
			if (isEmpty(action?.payload?.data)) return state;

			let scots = cloneDeep(state);

			// This is to insert new record created from Manage IT Application in the SCOT IT Application list
			let itApplication = action.payload.data;
			itApplication.forEach((itApp) => {
				if (itApp.scots !== null) {
					let scotList = scots?.data?.filter((scot) => itApp.scots.includes(scot.id));
					scotList?.forEach((scot) => {
						if (scot.itApplications !== null) {
							let indx = scot.itApplications.findIndex((f) => itApp.id === f.id);
							if (indx === -1) {
								scot.itApplications.push({
									controlId: [],
									scotId: scot.id,
									itApplicationName: itApp.itApplicationName,
									isServiceOrganization: itApp.isServiceOrganization,
									aggregateITEvaluationTypeId: itApp.aggregateITEvaluationTypeId ?? null,
									id: itApp.id
								});
							}
						}
					});
				}
			});

			// This is to remove the record from SCOT IT Application list which is deleted from Manage IT Application
			scots?.data?.forEach((scot) => {
				scot.itApplications?.forEach((itApp) => {
					let itAppScotIndex = itApplication.findIndex((itAppObj) => itAppObj.id === itApp.id);
					if (itAppScotIndex === -1) {
						let scotItAppIndex = scot.itApplications.findIndex((itAppObj) => itAppObj.id === itApp.id);
						scot.itApplications.splice(scotItAppIndex, 1);
					}
				});
			});

			// This is to unrelate the SCOT IT Application from IT Application
			scots?.data?.forEach((scot) => {
				itApplication.forEach((itApp) => {
					if (itApp.scots !== null) {
						let itAppScotIndex = itApp.scots.findIndex((itAppScot) => itAppScot.scotId === scot.id);
						let itAppScotIndex2 = itApp.scots.findIndex((scotId) => scotId === scot.id);
						let isNotExist = itAppScotIndex === itAppScotIndex2;
						if (scot?.itApplications !== null) {
							let scotItAppIndex = scot.itApplications.findIndex(
								(itAppObj) => itAppObj.id === itApp.id && itAppObj.scotId === scot.id
							);
							if (scotItAppIndex !== -1 && isNotExist) {
								// This is to remove the IT Application from SCOT IT Application list
								scot.itApplications.splice(scotItAppIndex, 1);
							} else if (scotItAppIndex !== -1 && !isNotExist) {
								// This is to update the IT Application name in SCOT IT Application list
								scot.itApplications[scotItAppIndex].itApplicationName = itApp.itApplicationName;
							}
						}
					}
				});

				// When relating/unrelating IT Application from SCOT, sort the IT Application list
				scot?.itApplications?.sort((itApp1, itApp2) =>
					itApp1.itApplicationName.localeCompare(itApp2.itApplicationName)
				);
			});

			return scots;
		}
		case UNRELATE_ACCOUNT_FROM_ALL_SCOTS_WHEN_DELETED: {
			let scots = {...state};
			if (scots.data) {
				let newScotList = scots.data.map((scot) => {
					scot = {...scot, accounts: deleteAccountFromScot(scot.accounts, action.accountId)};
					return scot;
				});
				scots.data = newScotList;
				return scots;
			} else {
				return state;
			}
		}
		case UPDATE_ALL_ACCOUNT_IN_SCOTLIST_WHEN_ACCOUNT_UPDATED: {
			if (state.data && action.accounts !== undefined && action.accounts !== null) {
				let newScots = _.cloneDeep(state);
				const accountMap = new Map(action.accounts.map((acc) => [acc.id, acc]));
				newScots.data.forEach((scot) => {
					scot.accounts = scot.accounts?.filter((scotAccount) => {
						const account = accountMap.get(scotAccount.accountId);
						if (account) {
							scotAccount.accountName = account.accountName;
							scotAccount.hasEstimate = account.hasEstimate;
							return true;
						}
						return false;
					});
				});
				return newScots;
			} else {
				return state;
			}
		}
		case FILTER_SCOTS_BY_ACCOUNT_TYPE:
			let scots = cloneDeep(state);
			if (scots.data) {
				let newScotList = scots.data.map((scot) => {
					if (scot.accounts) {
						scot.accounts = scot.accounts.filter(
							(account) =>
								account.accountTypeId === AccountType.Significant ||
								account.accountTypeId === AccountType.SignificantDiscloure
						);
					}
					return scot;
				});
				scots.data = newScotList;
				return scots;
			} else {
				return state;
			}
		default:
			return state;
	}
}

// pull scots from api results
export function formatScots(scots) {
	let formattedScots = {};
	if (scots && scots[0] && scots[0].scots && scots[0].scots.length > 0) {
		formattedScots = cloneDeep(scots[0].scots);
		formattedScots.riskId = scots[0].riskId;
		formattedScots.assertionId = scots[0].assertions[0].id;
		formattedScots.riskTypeId = scots[0].riskTypeId;
	}
	return formattedScots;
}
